<template>
  <button class="btn btn-sm btn-outline-gray mr-1 mb-1 mt-1" @click="showForm=true" v-if="changeGroupPermission">
    <i class="fa fa-plane"></i>
    Chuyển nhóm
    <b-modal v-model="showForm" title="Đổi nhóm chăm sóc" no-close-on-esc no-close-on-backdrop no-enforce-focus size="lg">
      <user-group-select-form attribute="group" :model="formModel" :errors="formErrors" label="Chọn nhóm"></user-group-select-form>
      <user-select
          v-if="formModel.group"
          label="Chọn BSTN/BSPN (bác sỹ trưởng nhóm hoặc bác sỹ phó nhóm sẽ trực tiếp theo dõi bệnh nhân)"
          :model="formModel"
          attribute="seniorDoctorUser"
          :errors="formErrors"
          :roles-filter="['bac-sy-truong-nhom', 'bac-sy-pho-nhom']"
          :group-filter="formModel.group"
      ></user-select>
      <b-spinner v-if="seniorDoctorLoading" class="text-center"></b-spinner>
      <div class="row" v-else-if="seniorDoctor">
        <div class="col">
          <div class="alert alert-warning">
            <p><b>LƯU Ý:</b> Cần liên hệ với Bác sỹ vừa được chọn bên trên trước khi thực hiện hành động chuyển nhóm bệnh nhân. Thông tin liên hệ như sau:</p>
            <p><b>Họ và tên bác sỹ: </b>{{seniorDoctor.name}}</p>
            <p>
              <b>Số nhánh: </b>
              <a @click="makeCall(seniorDoctor.ext)"
                 href="javascript:;" v-b-tooltip="'Nhấn để gọi nội bộ'">{{seniorDoctor.ext}}</a>
            </p>
            <p><b>Email: </b>{{seniorDoctor.email ? seniorDoctor.email : 'Chưa cập nhật'}}</p>
            <p>
              <b>Số điện thoại: </b>
              <a @click="makeCall(seniorDoctor.phone)" v-if="seniorDoctor.phone"
                 href="javascript:;" v-b-tooltip="'Nhấn để gọi nội bộ'">{{seniorDoctor.phone}}</a>
              <span v-else>Chưa cập nhật</span>
            </p>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('cancel') }}
        </b-button>
        <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="changeGroup">
          <b-spinner v-if="saveLoading" small></b-spinner>
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
  </button>
</template>

<script>
import UserGroupSelectForm from "@/components/UserGroupSelectForm";
import UserSelect from "@/components/UserSelect"

export default {
  props: ['benhNhan'],
  components: {
    UserGroupSelectForm,
    UserSelect
  },
  data() {
    return {
      showForm: false,
      formModel: {
        group: null,
        seniorDoctorUser: null
      },
      formErrors: [],
      saveLoading: false,
      seniorDoctor: null,
      seniorDoctorLoading: false
    }
  },
  methods: {
    changeGroup() {
      this.saveLoading = true;
      this.$service.post('/benh-nhan/change-group/' + this.benhNhan._id, this.formModel).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: 'Chuyển nhóm thành công',
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
          this.showForm = false;
          this.$bus.$emit('reloadBenhNhanList');
        } else {
          this.$swal({
            title: this.$t('error'),
            text: 'Chuyển nhóm thất bại',
            icon: 'error',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        this.saveLoading = false;
      })
    },
    makeCall(number) {
      this.$bus.$emit('makeCall', number);
    },
  },
  computed: {
    changeGroupPermission(){
      if (!this.benhNhan.communityCareTime) {
        return false
      }
      if (this.$store.state.user.role === 'owner') {
        return true
      }
      if (['bac-sy-truong-nhom', 'bac-sy-pho-nhom'].includes(this.$store.state.user.role)
          && this.$store.state.user.group
          && ['610e25b9d8ba7b532cc750a8', '610e362ce7aef55208d80670'].includes(this.$store.state.user.group)
          && this.benhNhan.group
          && ['610e25b9d8ba7b532cc750a8', '610e362ce7aef55208d80670'].includes(this.benhNhan.group._id)
      ) {
        return true
      }
      return false
    }
  },
  watch: {
    "formModel.seniorDoctorUser": {
      handler(val) {
        if (val) {
          this.seniorDoctorLoading = true;
          this.$bgService.get(`/user/${val}`).then(response => {
            if (response && response.data) {
              this.seniorDoctor = response.data
            }
          }).finally(() => {
            this.seniorDoctorLoading = false;
          })
        } else {
          this.seniorDoctor = null;
        }
      }
    },
    "formModel.group": {
      handler() {
        this.formModel.seniorDoctorUser = null;
      }
    }
  }
}
</script>